module.exports = __webpack_public_path__ + "assets/keypad-sounds/dingdong-26db87202f0792f54f37809b09cc4d2b.wav";